// ** Navigation sections imports

import pages from "./pages";

import dashboards from "./dashboards";
import misc from "./misc";
import brands from "./brands";
import brandsV2 from "./brands-v2";
import supplier from "./suppliers";
// ** Merge & Export
export default [
  // ...misc,
  // ...dashboards,
  ...pages,
  // ...supplier,
  ...brandsV2
  // ...brands,
]
